import { useMutation } from "@apollo/client/react";
import { UPDATE_TEMPLATE_EXTRACTION_FIELDS } from "../../mutations/invoiceInterpretationTemplates/updateTemplateExtractionFields";
import type { TemplateFieldInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateTemplateExtractionFields = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(
    UPDATE_TEMPLATE_EXTRACTION_FIELDS,
    { onCompleted, onError }
  );

  const updateTemplateExtractionFields = async ({
    input,
    templateId,
    clientIdentifier,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    input: TemplateFieldInput[];
  }) => {
    return mutation({
      variables: { templateId, clientIdentifier, input },
    });
  };

  return { updateTemplateExtractionFields, loading, error, data };
};
